export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/dfffdcc654f425d556d7485c2bf841db.svg";